module.exports = __webpack_public_path__ + "img/paintball.f4175410.jpg";